export enum CookieKeys {
  hideReminderCountingPopup = 'hideReminderCountingPopup',
}
